import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  AuthLayout,
  EmailSignInForm,
  EmailSignUpForm,
} from "../components/auth";
import { Link, Typography, IconButton, Box } from "@mui/joy";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const AuthPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const mode = searchParams.get("mode") || "signin";

  const isSignUp = mode === "signup";

  return (
    <AuthLayout
      title={isSignUp ? "Create your account" : "Welcome back"}
      subtitle={isSignUp ? "Start your travel journey" : "Sign in to continue"}
    >
      {/* Back button */}
      <Box sx={{ position: "absolute", top: 16, left: 16 }}>
        <IconButton
          variant="plain"
          onClick={() => navigate("/")}
          sx={{ color: "#6B6B6B" }}
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>

      {isSignUp ? (
        <EmailSignUpForm />
      ) : (
        <EmailSignInForm onSuccess={() => navigate("/")} />
      )}

      <Typography level="body-sm" sx={{ mt: 3, color: "#6B6B6B" }}>
        {isSignUp ? "Already have an account? " : "Don't have an account? "}
        <Link
          component="button"
          onClick={() =>
            navigate(`/auth?mode=${isSignUp ? "signin" : "signup"}`)
          }
          sx={{ cursor: "pointer" }}
        >
          {isSignUp ? "Sign in" : "Sign up"}
        </Link>
      </Typography>
    </AuthLayout>
  );
};
